<template>
  <div class="coo-modal-card modal-card" style="width: auto">
    <section class="modal-card-body">
      <h2><strong>Country Codes List</strong></h2>
      <table width="50%">
        <tr>
          <td width="20%">
            <option v-for="coo in cooList" :value="coo" :key="coo.id">
              {{ coo }}
            </option>
          </td>
        </tr>
      </table>
    </section>
    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Close
      </button>
    </footer>
  </div>
</template>

<script>
export default {
  name: "CountryCodes",
  props: ["cooList"],
  data() {
    return {
      classes: "",
      coo: ""
    };
  }
};
</script>
<style scoped></style>
